/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/MaxDiscount/Value/ValueInput/Content",
  onChange
  
}) {
let rulesetMaxDiscountValueValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount.value',
})
let rulesetMaxDiscountValueChangeData = fromData.useDataChange({ viewPath,
context: 'ruleset',
path: 'max_discount.value',
})
let rulesetMaxDiscountTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount.type',
})
let constantData = 'percentage'
let aggregateData = fromAggregate.equals(rulesetMaxDiscountTypeValueData, constantData)
let rulesetMaxDiscountTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'max_discount.type',
})
let constantData1 = 'amount'
let aggregateData1 = fromAggregate.equals(rulesetMaxDiscountTypeValueData1, constantData1)
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 type="number"
 data="ruleset.max_discount.value"
 value={rulesetMaxDiscountValueValueData}
 onChange={rulesetMaxDiscountValueChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 width="100%"
 placeholder={aggregateData ? "Enter %" : aggregateData1 ? "Enter $" : "-"}
 data={aggregateData ? "ruleset.max_discount.type" : "ruleset.max_discount.type"}
 data={aggregateData ? "ruleset.max_discount.type" : "'percentage'"}
 aggregate={aggregateData1 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}